/**
 * Constantes relacionadas ao sistema de update do Service Worker.
 *
 * IMPORTANTE: Esta constante deve ser idêntica à definida em:
 * src/app/constants/app-update.constants.ts
 */

/**
 * Chave do localStorage que indica presença de atualização pendente.
 *
 * Ciclo de vida:
 * 1. SwUpdate detecta nova versão → flag = 'true'
 * 2. Usuário vê snackbar "Há uma atualização disponível"
 * 3. [CENÁRIO A] Usuário clica "Atualizar" → flag removida → reload
 * 4. [CENÁRIO B] Token expira (401) → interceptor verifica flag → reload → flag removida
 */
export const APP_UPDATE_PENDING_KEY = 'ls.app.update-pending';

